import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.typography.size.medium};

  + div {
    margin-top: ${({ theme }) => theme.spacing.base.sm};
  }
`;

export const ServiceLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ServiceInfo = styled.button`
  align-self: center;
  background-color: white;
  border: none;
  display: flex;
  flex-direction: row;
  margin-left: auto;
  margin-right: ${({ theme }) => theme.spacing.base.xs};
  outline: none;
  padding: 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

export const ServiceName = styled.div`
  display: block;
  font-size: ${({ theme }) => theme.typography.size.medium};
  width: 100%;
  white-space: normal;
`;

export const ServiceLabelButtonWrapper = styled.div``;

export const ServiceLabelButton = styled.button`
  background: transparent;
  border: 0;
  display: inline-block;
  outline: none;
  padding: 0;
`;
